"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Happy = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
exports.Happy = function (props) {
    var cx = props.cx, cy = props.cy, stroke = props.stroke;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(recharts_1.Dot, __assign({ cx: cx, cy: cy, r: 12 }, { fill: stroke, opacity: 0.3 }, { className: 'hover-shape' })),
        react_1.default.createElement("svg", { x: cx - 4.5, y: cy - 4.5, width: 10, height: 10, fill: 'green', viewBox: '0 0 1024 1024' },
            react_1.default.createElement("path", { d: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z' }))));
};
//# sourceMappingURL=Happy.js.map